import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import FavoriteListItem from 'src/components/molecules/FavoriteListItem';
import TopBar from 'src/components/molecules/TopBar';
import TopBarHomeButton from 'src/components/atoms/TopBarHomeButton';
import { FavoriteDB } from 'src/data/datatypes';
import { deleteFavorite, getFavorites } from 'src/services/DBService/DbService';
import { getPathNameAndRestoreTransientStateProperties } from '../components/organisms/Sessions/Session.logic';

export default function FavoriteOverview(props: Record<string, never>) {
    const [favorites, setFavorites] = useState<FavoriteDB[]>([]);
    const navigate = useNavigate();

    useEffect(() => {
        const loadData = async () => {
            setFavorites(await getFavorites());
        };
        loadData();
    }, []);

    const viewFavorite = (favorite: FavoriteDB) => {
        const match = favorite._id.match(/^fav_(.*)$/);
        if (match !== null) {
            const pathname = getPathNameAndRestoreTransientStateProperties(match[1]);
            navigate(pathname);
        }
    };

    const removeFavorite = async (favorite: FavoriteDB) => {
        await deleteFavorite(favorite._id);
        setFavorites(old => old.filter(fav => fav._id !== favorite._id));
    };

    let favoriteItems: JSX.Element | JSX.Element[] = favorites.map((favorite, i) => (
        <FavoriteListItem
            key={i}
            item={favorite}
            viewItem={() => viewFavorite(favorite)}
            removeItem={() => removeFavorite(favorite)}
        />
    ));

    if (favorites.length === 0) {
        favoriteItems = <div className="empty-favorite-list">
            <img className="empty-favorite-list-image" />
            <p className="empty-favorite-list-hint">
                Aktuell hast Du noch keine Favoriten ausgewählt. Speichere Seiten innerhalb einer Übung, die Dir besonders gut gefallen oder auf denen Du etwas Neues gelernt hast, indem Du auf den Stern oben rechts klickst.
            </p>
        </div>;
    }

    return (
        <div className="content favorite-overview">
            <TopBar
                title={'Favoriten'}
                icon={'icon_star.svg'}
                leftButtons={[<TopBarHomeButton />]}
            />
            <div className="content-container content-favorite-overview">
                {favoriteItems}
            </div>
        </div>
    );
}